<template>
  <div class="post-component">
    <!-- [ div.container -->
    <div class="container">
      <div class="contents">
        <Header class="header--post">
          <template #title>来歴・逸話</template>
          <template #menu>
            <router-link to="/edit" class="reedit-img">
              <CancelButton class="header-btn">戻る</CancelButton>
            </router-link>
            <EnterButton
              class="header-btn btn-complete"
              @click="onClickCompleteBtn"
            >
              完成
            </EnterButton>
          </template>
        </Header>

        <div class="contents__body">
          <div class="post">
            <p class="post__lead">家紋にまつわる来歴や逸話を記録しよう！</p>
            <textarea
              v-model="writeText"
              class="write-text"
              placeholder="例）1000年続く名門ながら、直近の50代当主の放蕩と急死により跡取りが潰え、長きに渡る歴史に幕を降ろすこととなった。"
              rows="6"
            ></textarea>
            <p class="post__notice">
              ※家系、血統、家柄・地位、成り立ち、由来など、<br />好きな説明を自由に入れよう！
            </p>
          </div>
        </div>

        <div class="edit-area">
          <canvas
            id="edit-object-canvas"
            width="750"
            height="750"
            :data-baseillust-src="canvasImgSrc"
            :data-baseillust-x="trimPoint.x"
            :data-baseillust-y="trimPoint.y"
            :data-baseillust-scale="trimPoint.scale"
            :data-edit-data="JSON.stringify(savedEditData)"
            :data-font="dataFontSrc"
          >
            <img alt="背景" class="canvas-bg" />
          </canvas>

          <canvas
            id="frame-canvas"
            width="807"
            height="997"
            style="display: none"
          >
          </canvas>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, onUnmounted, ref } from "vue";
import { useRouter } from "vue-router";
import { useGlobalStore } from "@/stores/global";
import axios from "axios";
import EnterButton from "@/components/EnterButton.vue";
import CancelButton from "@/components/CancelButton.vue";
import Header from "@/components/Header.vue";
import Edit from "@/javascripts/image/edit";

export default defineComponent({
  name: "Write",
  components: {
    EnterButton,
    CancelButton,
    Header,
  },
  setup() {
    const router = useRouter();
    const toSelect = () => router.push({ name: "select" });
    const toEdit = () => router.push({ name: "edit" });
    const toPost = () => router.push({ name: "post" });

    const edit = new Edit();

    const { imageEditor } = useGlobalStore();
    const selectedImage = imageEditor.selectedImage;
    if (!selectedImage) {
      toSelect();
      return;
    }
    let canvasImgSrc = "";
    if (imageEditor.isSelectedImageUploaded()) {
      // アップロード画像を使用する場合
      canvasImgSrc = selectedImage.src as string;
    } else {
      // 選択画像を使用する場合
      canvasImgSrc = "/app/assets/img/base_illust/original/";
      canvasImgSrc += selectedImage.fileName;
    }
    const trimPoint = imageEditor.trimPoint;
    const savedEditData = imageEditor.editData;

    const dataFontSrc = "/app/assets/css/image/icomoon-font.css";

    const writeText = ref<String>("");

    onMounted(() => {
      edit.setupWriteView();
    });

    onUnmounted(() => {});

    function onClickCompleteBtn() {
      complete();
    }

    async function complete() {
      // canvas側の更新
      edit.completeEdit(writeText.value as string);

      // store側への画像保存
      const completedImage = edit.getCompletedImage();
      imageEditor.completeEditing(completedImage);

      // store側への編集情報保存
      save();

      // 画像アップロード: 編集完了と1:1でアップロードするため、ここで行う
      await uploadImage(completedImage);

      // 遷移
      toPost();
    }

    function save(): boolean {
      const editData = edit.getEditData();
      if (!editData) {
        return false;
      }
      imageEditor.saveEditData(editData);
      return true;
    }

    async function uploadImage(image: string) {
      const ImageUploadAPI = "/api/image/upload";
      const params = new FormData();
      params.append("image", image);

      let imageId = null;
      await axios
        .post(ImageUploadAPI, params)
        .then(function (response) {
          const data = response.data;
          if (data.result == true) {
            imageId = data.image_id;
            imageEditor.completeUploading(imageId);
          } else {
            alert("画像のアップロードに失敗しました。");
          }
        })
        .catch(function (error) {
          alert(error);
        });

      return imageId;
    }

    return {
      toEdit,
      writeText,
      canvasImgSrc,
      trimPoint,
      savedEditData,
      dataFontSrc,
      onClickCompleteBtn,
    };
  },
});
</script>

<style scoped>
@import "/app/assets/css/style.css";
/** TODO postと共通のスタイルを使用しているので、共通化やclass名の汎用化等 */
@import "/app/assets/css/post.css";
.header-btn {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.post__lead {
  color: #e6b422;
  font-family: "Sawarabi Mincho", sans-serif;
  text-shadow: 1px 1px 2px #666666;
  font-size: 3rem;
}
.post-img__img {
  background: #ffffff;
}
.write-text {
  background-color: white;
  width: 80%;
  height: 20vh;
  /**
    * font-sizeが16pxより小さいと、textareaフォーカス時にズームされてしまう
    * viewportが0.5のため、倍のサイズが必要
    */
  font-size: 32px;
  transform: scale(0.8);
}
</style>
